import React, { useEffect, useRef } from "react";
import { Modal } from '@appkit4/react-components/modal';
import { Button } from '@appkit4/react-components/button';
import { Link } from "react-router-dom";

const InitialDialog: React.FC = () => {

  const [visible, setVisible] = React.useState(false);
  useEffect(() => {
    setVisible(true)
  }, [])
  return (<>
    <Modal
      visible={visible}
      title={"Notice"}
      ariaLabel={"Notice"}
      onCancel={() => setVisible(false)}
      modalStyle={{ width: '33.75rem' }}
      footerStyle={{ 'paddingTop': '8px', 'marginTop': '-8px', 'minHeight': '64px' }}
      header={""}
      icons={""}
      footer={
        <>
          <Button onClick={() => setVisible(false)}>I Agree</Button>
        </>
      }
      bodyStyle={{ minHeight: '92px' }}
    >
      <p>Please note: I am an AI Assistant, which means I can process information quickly, but I may not always fully understand complex or nuanced requests. My responses are based on the data I have access to, so for critical or sensitive issues, please consult a subject-matter expert or contact our <Link className="color" to="/help"> support team</Link>.. for assistance. By clicking agree, you acknowledge the constraints of the tool and will ensure you will review all content generated.</p>
    </Modal>
  </>);
}

export default InitialDialog